<template>
    <app-layout title="Bestekken">
        <template #header>
            <page-title :title="title" />
        </template>

        <template #pageContent>
            <Form @submitted="postForm" class="w-1/2">
                <Input
                    type="text"
                    label="Naam"
                    name="name"
                    :required="true"
                    v-model="form.name"
                    :error="form.errors.name"
                    layout="vertical"
                />

                <h3 class="mt-4">Duedates</h3>
                <Table id="estimate-assignment-types" :values="assignmentTypes" class="mb-4">
                    <thead>
                    <tr>
                        <Th :sort="false"></Th>
                        <Th id="name">Opdracht</Th>
                        <Th id="urgent">Urgent</Th>
                        <Th id="non_urgent">Niet urgent</Th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="assignmentType in state.sortedValues['estimate-assignment-types']" :key="assignmentType.id">
                            <Td>
                                <Input
                                    :name="String(assignmentType.id)"
                                    :id="String(assignmentType.id)"
                                    type="checkbox"
                                    :checked="assignmentTypeIds.includes(assignmentType.id)"
                                    :value="assignmentType.id"
                                    @click="assignmentTypeSelection"
                                />
                            </Td>
                            <Td>{{ assignmentType.name }}</Td>
                            <Td>
                                <Input
                                    type="number"
                                    :name="String(assignmentType.id) + '_urgent'"
                                    :disabled="assignmentTypeIds.includes(assignmentType.id) === false"
                                    v-model="assignmentTypeDays[assignmentType.id]['urgent']"
                                />
                            </Td>
                            <Td>
                                <Input
                                    type="number"
                                    :name="String(assignmentType.id) + '_urgent'"
                                    :disabled="assignmentTypeIds.includes(assignmentType.id) === false"
                                    v-model="assignmentTypeDays[assignmentType.id]['non_urgent']"
                                />
                            </Td>
                        </tr>
                    </tbody>
                </Table>

                <Button
                    buttonClass="save"
                    title="Opslaan"
                    text="Opslaan"
                    type="submit"
                    class="self-end"
                    :loading="form.processing"
                />
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'

import store from '@/store'
import { useForm } from '@inertiajs/inertia-vue3'
import { ref } from 'vue'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        Form,
        Input,
    },
    props: [
        'title',
        'estimate',
        'assignmentTypes',
    ],
    setup (props)
    {
        let assignmentTypeIds = ref([])
        let assignmentTypeDays = ref([])

        Object.values(props.assignmentTypes).forEach(function(assignmentType)
        {
            assignmentTypeDays.value[assignmentType.id] = {
                'urgent': assignmentType.urgent,
                'non_urgent': assignmentType.non_urgent,
            }
        })

        if (props.estimate)
        {
            Object.values(props.estimate.estimate_duedates).forEach(function(estimate_duedate)
            {
                if (!assignmentTypeIds.value.includes(estimate_duedate.assignment_type_id))
                {
                    assignmentTypeIds.value.push(parseInt(estimate_duedate.assignment_type_id))
                }

                assignmentTypeDays.value[estimate_duedate.assignment_type_id]['urgent'] = estimate_duedate.urgent
                assignmentTypeDays.value[estimate_duedate.assignment_type_id]['non_urgent'] = estimate_duedate.non_urgent
            })
        }

        const form = useForm({
            estimate_id: (props.estimate !== null) ? props.estimate.id : null,
            name: (props.estimate !== null) ? props.estimate.name : null,
        })

        function assignmentTypeSelection(event)
        {
            //Add or remove order id from ordersToImport
            if (event.target.checked)
            {
                assignmentTypeIds.value.push(parseInt(event.target.value))
            }
            else
            {
                const index = assignmentTypeIds.value.findIndex(assignment_type_id => assignment_type_id == event.target.value)

                if (index > -1)
                {
                    assignmentTypeIds.value.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
        }

        function postForm()
        {
            form.transform((data) => (
                {
                    ...data,
                    assignment_type_ids: assignmentTypeIds.value,
                    assignment_type_days: assignmentTypeDays.value,
                }
            )).post(route('estimates.store'))
        }

        return {
            state: store.state,
            ...store,
            assignmentTypeIds,
            assignmentTypeSelection,
            assignmentTypeDays,
            form,
            postForm
        }
    },
}

</script>
